import {
  GlobalEvents,
  SnippetElement,
  defineElement,
  globalOn,
  liquidValue,
  on,
  onClick,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass,
  __pow
} from "./chunk-CFQW6ARL.js";

// src/snippets/pb-shop-engraving-v2/pb-shop-engraving-v2.ts
var PbShopEngravingV2 = class extends SnippetElement {
  constructor() {
    super(...arguments);
    this.isOpenEngravingInfo = false;
    this.addonId = this.engravingAddonId ? this.engravingAddonId : this.defaultAddonId;
    this.canvasContext = null;
    this.canvasBaseData = void 0;
    this.canvasCurrentData = void 0;
    this.drawAreaFormat = "";
    this.drawAreaAxisX = 0;
    this.drawAreaAxisY = 0;
    this.drawAreaWidth = 0;
    this.drawAreaHeight = 0;
    this.drawAreaRadius = 0;
    this.previewText = "";
    this.previewTextCenterX = 0;
    this.previewTextCenterY = 0;
    this.fontFamily = "";
    this.fontSize = 0;
    this.fontSizeStep = 4;
    this.fontSizePreset = 0;
    this.fontMin = 0;
    this.fontMax = 0;
    this.fontColor = "";
    this.lineSpacing = 10;
    this.cursorPosition = [0];
    this.textValidation = new RegExp("^[-A-Za-z0-9 .:;,\xB0\xB4\u201C\"`!?+*=&()'/|#\xE4\xF6\xFC\xDF\xC4\xD6\xDCSS\xE2\xE0\xE6\xE7\xEB\xEA\xE9\xE8\xEF\xCE\xF4\u0153\xFB\xF9\xFF\xC2\xC0\xC6\xC7\xCB\xCA\xC9\xC8\xCF\xCE\xD4\u0152\xDB\xD9\u0178\xE0\xE9\xE8\xEF\xED\xEC\xF3\xF2\xFA\xF9\xC0\xC9\xC8\xCF\xCD\xCC\xD3\xD2\xDA\xD9\xA1\xBF\xAA\xE1\xE7\xE9\xED\xF1\xBA\xF3\xFC\xFA\xA1\xBF\xAA\xC1\xC7\xC9\xCD\xD1\xBA\xD3\xDC\xDA\xF8\xE5\xD8\xC5\r\n]+$");
    this.pxConverter = 0;
    this.validEngraving = true;
    this.errorType = "";
  }
  connectedCallback() {
    return __async(this, null, function* () {
      var me = this;
      yield this.waitForNextAnimationFrame();
      if (me.engravingObject != null && this.canvas != null) {
        me.setBaseValues();
      }
      window.addEventListener("resize", function() {
        me.cleanCanvas();
        me.prepareCanvasBase();
        me.hideErrors();
        me.updateCanvas();
      });
      window.addEventListener("keydown", function(e) {
        if (e.key == "Enter" && e.target == me.textInput) {
          if (me.textInput.type != "textarea") {
            e.preventDefault();
          }
        }
      }, true);
    });
  }
  openModal() {
    var _a;
    (_a = this.engravingModal) == null ? void 0 : _a.toggle();
    if (this.textInput.type == "textarea") {
      this.textInput.style.height = this.textInput.scrollHeight + "px";
    }
    this.prepareCanvasBase();
    this.buildCanvas();
  }
  closeModal() {
    var _a, _b;
    (_a = this.engravingModal) == null ? void 0 : _a.toggle();
    this.setCurrentCanvas((_b = this.canvasContext) == null ? void 0 : _b.getImageData(0, 0, this.canvas.width, this.canvas.height));
    this.cleanCanvas();
  }
  handleClick(button) {
    if (!button.hasAttribute("active")) {
      this.settingContainers.forEach((container) => {
        if (!container.classList.contains("hidden")) {
          container.classList.add("hidden");
          container.classList.remove("block");
        }
        if (button.getAttribute("name") == container.dataset.container) {
          container.classList.add("block");
          container.classList.remove("hidden");
        }
      });
      this.settingContainerButtons.forEach((containerButton) => {
        containerButton.children[0].classList.toggle("font-bold");
        containerButton.classList.toggle("underline");
        containerButton.toggleAttribute("active");
      });
    }
  }
  handleOpenButtonClick(elm) {
    const index = parseInt(elm.dataset.openButton);
    if (this.accordions[index].isOpen) {
      this.close(index);
    } else {
      this.closeAll();
      this.open(index);
    }
  }
  open(index) {
    this.accordions[index].open();
    this.chevrons[index].classList.remove("rotate-180");
  }
  close(index) {
    this.accordions[index].close();
    this.chevrons[index].classList.add("rotate-180");
  }
  closeAll() {
    this.accordions.forEach((accordion, index) => this.close(index));
  }
  /* CANVAS */
  //prepares base canvas for later (re)draw
  prepareCanvasBase() {
    var _a, _b;
    var pxRatio = window.devicePixelRatio > 1 ? window.devicePixelRatio : 2;
    this.canvas.width = Math.round(this.canvasContainer.offsetWidth) * pxRatio;
    this.canvas.height = this.canvas.width;
    this.canvas.style.width = this.canvasContainer.offsetWidth + "px";
    this.canvas.style.height = this.canvas.style.width;
    this.pxConverter = this.canvas.width / 500;
    if (this.engravingImage != null) {
      (_a = this.canvasContext) == null ? void 0 : _a.drawImage(this.engravingImage, 0, 0, this.canvas.width, this.canvas.height);
    }
    this.calculateDrawArea();
    this.canvasBaseData = (_b = this.canvasContext) == null ? void 0 : _b.getImageData(0, 0, this.canvas.width, this.canvas.height);
    this.cleanCanvas();
  }
  //calculates and sets the necessary pixel measurements for later uses
  calculateDrawArea() {
    this.drawAreaAxisX = this.engravingObject.draw_area_x_axis * this.pxConverter;
    this.drawAreaAxisY = this.engravingObject.draw_area_y_axis * this.pxConverter;
    this.drawAreaWidth = this.engravingObject.draw_area_width * this.pxConverter;
    this.drawAreaHeight = this.engravingObject.draw_area_height * this.pxConverter;
    this.drawAreaRadius = this.engravingObject.draw_area_radius * this.pxConverter;
    if (this.drawAreaFormat == "rectangle") {
      this.previewTextCenterX = (this.drawAreaAxisX * 2 + this.drawAreaWidth) / 2;
      this.previewTextCenterY = (this.drawAreaAxisY * 2 + this.drawAreaHeight) / 2;
    } else if (this.drawAreaFormat == "circle") {
      this.previewTextCenterX = this.drawAreaAxisX;
      this.previewTextCenterY = this.drawAreaAxisY;
    }
  }
  //create draw area
  buildDrawArea() {
    var _a, _b, _c;
    var lineColor = this.validEngraving ? "green" : "red";
    this.canvasContext.strokeStyle = lineColor;
    this.canvasContext.lineWidth = 3;
    this.canvasContext.setLineDash([10, 10]);
    this.canvasContext.fillStyle = this.fontColor;
    if (this.drawAreaFormat == "rectangle") {
      this.canvasContext.strokeRect(this.drawAreaAxisX, this.drawAreaAxisY, this.drawAreaWidth, this.drawAreaHeight);
      if (this.validEngraving != true) {
        this.canvasContext.fillStyle = "rgb(212, 212, 212, 0.5)";
        this.canvasContext.fillRect(this.drawAreaAxisX, this.drawAreaAxisY, this.drawAreaWidth, this.drawAreaHeight);
      }
    } else if (this.drawAreaFormat == "circle") {
      (_a = this.canvasContext) == null ? void 0 : _a.beginPath();
      (_b = this.canvasContext) == null ? void 0 : _b.arc(this.drawAreaAxisX, this.drawAreaAxisY, this.drawAreaRadius, 0, 2 * Math.PI);
      if (this.validEngraving != true) {
        this.canvasContext.fillStyle = "rgb(212, 212, 212, 0.5)";
        this.canvasContext.fill();
      }
      (_c = this.canvasContext) == null ? void 0 : _c.stroke();
    }
  }
  //builds the basic canvas
  buildBaseCanvas() {
    var _a;
    (_a = this.canvasContext) == null ? void 0 : _a.putImageData(this.canvasBaseData, 0, 0);
  }
  //builds canvas on first view i.e. opening modal
  buildCanvas() {
    var _a;
    if (this.getCurrentCanvas() != void 0) {
      (_a = this.canvasContext) == null ? void 0 : _a.putImageData(this.getCurrentCanvas(), 0, 0);
    } else {
      this.buildBaseCanvas();
      this.buildDrawArea();
    }
  }
  cleanCanvas() {
    var _a;
    (_a = this.canvasContext) == null ? void 0 : _a.clearRect(0, 0, this.canvas.width, this.canvas.height);
  }
  setCurrentCanvas(data) {
    this.canvasCurrentData = data;
  }
  getCurrentCanvas() {
    return this.canvasCurrentData;
  }
  //update canvas
  updateCanvas() {
    var _a;
    var fontFamily = this.getPreviewFont();
    var input = this.getPreviewText();
    var fontSize = this.getFontSize() * this.pxConverter;
    var fontContext = fontSize + "px " + fontFamily;
    this.cleanCanvas();
    this.buildBaseCanvas();
    this.canvasContext.font = fontContext;
    this.canvasContext.textAlign = "center";
    this.canvasContext.textBaseline = "middle";
    this.canvasContext.fillStyle = this.fontColor;
    this.drawText();
    this.validateEngraving(input);
    this.buildDrawArea();
    this.setCurrentCanvas((_a = this.canvasContext) == null ? void 0 : _a.getImageData(0, 0, this.canvas.width, this.canvas.height));
  }
  drawText() {
    var input = this.getPreviewText();
    var inputArray = input.split("\n");
    var adjustedYCoordinate = this.previewTextCenterY;
    inputArray.forEach((inputLine, i) => {
      if (i + 1 < inputArray.length) {
        var lineDimensions = this.getLineDimensions(inputLine);
        var nextLineDimenions = this.getLineDimensions(inputArray[i + 1]);
        adjustedYCoordinate -= (lineDimensions.lineDescent + nextLineDimenions.lineAscent + this.lineSpacing) / 2;
      }
    });
    inputArray.forEach((inputLine, i) => {
      var _a;
      var lineDimensions = this.getLineDimensions(inputLine);
      var nextLineDimenions = this.getLineDimensions(inputArray[i + 1]);
      (_a = this.canvasContext) == null ? void 0 : _a.fillText(inputLine, this.previewTextCenterX, adjustedYCoordinate);
      adjustedYCoordinate += lineDimensions.lineDescent + nextLineDimenions.lineAscent + this.lineSpacing;
    });
  }
  handleTextInput() {
    if (this.textInput.type == "textarea") {
      this.textInput.style.height = "auto";
      this.textInput.style.height = this.textInput.scrollHeight + "px";
    }
    this.setPreviewText(this.textInput.value);
    this.hideErrors();
    this.updateCanvas();
  }
  setPreviewText(input) {
    this.previewText = input;
  }
  getPreviewText() {
    return this.previewText;
  }
  validateEngraving(input) {
    this.validEngraving = true;
    this.errorType = "";
    this.submitButton.disabled = false;
    if (this.validateCharacters(input) != true) {
      this.validEngraving = false;
      this.errorType = "Character";
    }
    if (this.validEngraving != false && this.validateContent(input) != true) {
      this.validEngraving = false;
      this.errorType = "Empty";
    }
    if (this.validEngraving != false && this.validateBoundingBox(input) != true) {
      this.validEngraving = false;
      this.errorType = "BoundingBox";
    }
    if (!this.validEngraving) {
      this.submitButton.disabled = true;
      this.showError();
    }
  }
  //for characters (and symbols) with regex/letterCharCode
  validateCharacters(input) {
    let symbol;
    var validCharaters = true;
    input.split("").forEach((letter) => {
      const letterCharCode = letter.charCodeAt(0);
      if (letterCharCode > 59647) {
        symbol = document.querySelector('[lettercode="' + letterCharCode.toString() + '"]');
        if (symbol == null) {
          validCharaters = false;
          return;
        }
      } else {
        if (!this.textValidation.test(letter)) {
          validCharaters = false;
          return;
        }
      }
    });
    return validCharaters;
  }
  //validate existence of text in engraving
  validateContent(input) {
    if (input.length != 0) {
      return true;
    }
    return false;
  }
  //validate boundingBox
  validateBoundingBox(input) {
    var inputArray = input.split("\n");
    var validBoundingBox = true;
    var adjustedYCoordinate = this.previewTextCenterY;
    inputArray.forEach((inputLine, i) => {
      if (i + 1 < inputArray.length) {
        var lineDimensions = this.getLineDimensions(inputLine);
        var nextLineDimenions = this.getLineDimensions(inputArray[i + 1]);
        adjustedYCoordinate -= (lineDimensions.lineDescent + nextLineDimenions.lineAscent + this.lineSpacing) / 2;
      }
    });
    if (this.drawAreaFormat == "rectangle") {
      var lineHeightSum = 0;
      inputArray.forEach((inputLine, i) => {
        var lineDimensions = this.getLineDimensions(inputLine);
        if (lineDimensions.lineWidth > this.drawAreaWidth) {
          validBoundingBox = false;
        }
        adjustedYCoordinate += lineDimensions.lineAscent + lineDimensions.lineDescent + this.lineSpacing;
        lineHeightSum += lineDimensions.lineAscent + lineDimensions.lineDescent + this.lineSpacing;
      });
      if (lineHeightSum > this.drawAreaHeight) {
        validBoundingBox = false;
      }
    } else if (this.drawAreaFormat == "circle") {
      inputArray.forEach((inputLine, i) => {
        var lineCheck = this.checkCircleOverlap(inputLine, adjustedYCoordinate);
        var lineDimensions = this.getLineDimensions(inputLine);
        if (!lineCheck) {
          validBoundingBox = false;
        }
        adjustedYCoordinate += lineDimensions.lineAscent + lineDimensions.lineDescent + this.lineSpacing;
      });
    }
    return validBoundingBox;
  }
  checkCircleOverlap(input, adjustedYCoordinate) {
    var lineDimensions = this.getLineDimensions(input);
    var validBoundingBox = true;
    var textTopLeftX = this.drawAreaAxisX - lineDimensions.lineWidth / 2;
    var textTopLeftY = adjustedYCoordinate - (lineDimensions.lineAscent + lineDimensions.lineDescent) / 2;
    var textTopRightX = this.drawAreaAxisX + lineDimensions.lineWidth / 2;
    var textTopRightY = adjustedYCoordinate - (lineDimensions.lineAscent + lineDimensions.lineDescent) / 2;
    var textBottomLeftX = this.drawAreaAxisX - lineDimensions.lineWidth / 2;
    var textBottomLeftY = adjustedYCoordinate + (lineDimensions.lineAscent + lineDimensions.lineDescent) / 2;
    var textBottomRightX = this.drawAreaAxisX + lineDimensions.lineWidth / 2;
    var textBottomRightY = adjustedYCoordinate + (lineDimensions.lineAscent + lineDimensions.lineDescent) / 2;
    var textRectangle = [
      { x: textTopLeftX, y: textTopLeftY },
      { x: textTopRightX, y: textTopRightY },
      { x: textBottomLeftX, y: textBottomLeftY },
      { x: textBottomRightX, y: textBottomRightY }
    ];
    for (let { x, y } of textRectangle) {
      if (this.calculateDistanceToCenter(x, y, this.drawAreaAxisX, this.drawAreaAxisY) > this.drawAreaRadius) {
        validBoundingBox = false;
        break;
      }
    }
    return validBoundingBox;
  }
  showError() {
    for (var child of this.errorContainer.childNodes) {
      if (child.nodeType === Node.ELEMENT_NODE) {
        var errorMessage = child;
        if (errorMessage.getAttribute("error-type") == this.errorType) {
          errorMessage.classList.remove("hidden");
        }
      }
    }
  }
  hideErrors() {
    for (var child of this.errorContainer.childNodes) {
      if (child.nodeType === Node.ELEMENT_NODE) {
        var errorMessage = child;
        if (!errorMessage.classList.contains("hidden")) {
          errorMessage.classList.add("hidden");
        }
      }
    }
  }
  identifySymbol(button) {
    const symbol = button.innerHTML.trim();
    this.addSymbol(symbol);
  }
  //add symbol
  addSymbol(symbol) {
    const inputString = this.textInput.value;
    let newInputString = "";
    if (this.cursorPosition.length === 1) {
      newInputString = [
        inputString.slice(0, this.cursorPosition[0]),
        symbol,
        inputString.slice(this.cursorPosition[0])
      ].join("");
      this.cursorPosition = this.cursorPosition.map(function(num) {
        return num++;
      });
    } else {
      newInputString = [
        inputString.slice(0, this.cursorPosition[0]),
        symbol,
        inputString.slice(this.cursorPosition[1])
      ].join("");
      this.cursorPosition = this.cursorPosition.map(function(num) {
        return num++;
      }).slice(0, 1);
    }
    this.textInput.value = newInputString;
    this.setCursorPosition();
    this.handleTextInput();
  }
  updateFontFamily(button) {
    this.fontInputs.forEach((input) => {
      if (input.value != button.dataset.font) {
        input.checked = false;
      }
    });
    this.setFontFamily(button.dataset.font);
    this.hideErrors();
    this.updateCanvas();
  }
  resetFontFamily() {
    this.fontInputs.forEach((input, i) => {
      if (i == 0) {
        input.checked = true;
      } else {
        input.checked = false;
      }
    });
  }
  setFontFamily(newFamily) {
    this.fontFamily = newFamily;
  }
  getPreviewFont() {
    var previewFamily = this.fontFamily;
    if (previewFamily == "") {
      return this.identifyFont(this.fontInputs[0].value);
    } else {
      return this.identifyFont(previewFamily);
    }
  }
  identifyFont(fontAlias) {
    var fontName = "";
    switch (fontAlias) {
      case "The bold":
        fontName = "Josefin Sans";
        break;
      case "The romantic":
        fontName = "Rouge Script";
        break;
      case "The elegant":
        fontName = "Lora";
        break;
      case "The analog":
        fontName = "Special Elite";
        break;
      case "The cheeky":
        fontName = "Nanum Pen Script";
        break;
      case "The futuristic":
        fontName = "Offside";
        break;
      case "The straightforward":
        fontName = "Oswald";
        break;
      case "The handwritten":
        fontName = "Prelude FLF";
        break;
    }
    return fontName;
  }
  //font size
  getFontSize() {
    return this.fontSize;
  }
  setFontSize(newSize) {
    this.fontSize = newSize;
  }
  setFontSizePreview(fontSize) {
    this.fontSizeInput.value = String(fontSize);
  }
  setSmallFontSize(elm) {
    this.fontSizeButtons.forEach((button) => {
      var _a, _b, _c, _d;
      if (elm == button) {
        (_a = button.parentElement) == null ? void 0 : _a.classList.remove("border");
        (_b = button.parentElement) == null ? void 0 : _b.classList.add("border-2");
        button.classList.add("bg-phBreeze");
      } else {
        (_c = button.parentElement) == null ? void 0 : _c.classList.remove("border-2");
        (_d = button.parentElement) == null ? void 0 : _d.classList.add("border");
        button.classList.remove("bg-phBreeze");
      }
    });
    this.switchFontSize(this.fontMin, elm.children[0].innerHTML);
  }
  setMediumFontSize(elm) {
    this.fontSizeButtons.forEach((button) => {
      var _a, _b, _c, _d;
      if (elm == button) {
        (_a = button.parentElement) == null ? void 0 : _a.classList.remove("border");
        (_b = button.parentElement) == null ? void 0 : _b.classList.add("border-2");
        button.classList.add("bg-phBreeze");
      } else {
        (_c = button.parentElement) == null ? void 0 : _c.classList.remove("border-2");
        (_d = button.parentElement) == null ? void 0 : _d.classList.add("border");
        button.classList.remove("bg-phBreeze");
      }
    });
    this.switchFontSize(this.fontSizePreset, elm.children[0].innerHTML);
  }
  setLargeFontSize(elm) {
    this.fontSizeButtons.forEach((button) => {
      var _a, _b, _c, _d;
      if (elm == button) {
        (_a = button.parentElement) == null ? void 0 : _a.classList.remove("border");
        (_b = button.parentElement) == null ? void 0 : _b.classList.add("border-2");
        button.classList.add("bg-phBreeze");
      } else {
        (_c = button.parentElement) == null ? void 0 : _c.classList.remove("border-2");
        (_d = button.parentElement) == null ? void 0 : _d.classList.add("border");
        button.classList.remove("bg-phBreeze");
      }
    });
    this.switchFontSize(this.fontMax, elm.children[0].innerHTML);
  }
  switchFontSize(fontSize, sizecategory) {
    this.setFontSize(fontSize);
    this.setFontSizePreview(sizecategory);
    this.hideErrors();
    this.updateCanvas();
  }
  saveEngraving() {
    if (this.validEngraving) {
      this.engravingModal.close();
      var previewTextTransform = this.previewText.split("").map((letter) => letter === "\n" ? "||" : letter).join("");
      var fontSize = this.fontSizeInput ? this.fontSizeInput.value : null;
      var referenceCanvasDataString = this.createReferenceCanvas(700, 0.7);
      GlobalEvents.emit("engraving:set", {
        text: previewTextTransform,
        font: this.fontFamily,
        size: fontSize,
        reference: referenceCanvasDataString
      });
      this.engravingAddon.value = this.addonId;
      this.engravingButton.setAttribute("data-engraving-added", "");
    }
  }
  //create dataString for canvas reference image
  createReferenceCanvas(maxWidth, quality) {
    const canvasRatio = this.canvas.width / this.canvas.height;
    let referenceWidth = this.canvas.width;
    let referenceHeight = this.canvas.height;
    if (this.canvas.width > maxWidth) {
      referenceWidth = maxWidth;
      referenceHeight = Math.round(maxWidth / canvasRatio);
    }
    const tmpCanvas = document.createElement("canvas");
    tmpCanvas.width = referenceWidth;
    tmpCanvas.height = referenceHeight;
    const tmpContext = tmpCanvas.getContext("2d");
    tmpContext.fillStyle = "#fff";
    tmpContext.fillRect(0, 0, tmpCanvas.width, tmpCanvas.height);
    tmpContext.imageSmoothingQuality = "high";
    tmpContext.drawImage(this.canvas, 0, 0, tmpCanvas.width, tmpCanvas.height);
    const dataString = tmpCanvas.toDataURL("image/jpeg", quality);
    tmpCanvas.remove();
    return dataString;
  }
  setEngraving(elm, event) {
    this.engravingTextDisplay.innerHTML = event.detail.text;
    this.engravingText.value = event.detail.text;
    this.engravingFontDisplay.innerHTML = event.detail.font;
    this.engravingFont.value = event.detail.font;
    if (this.engravingObject.enable_font_size) {
      this.engravingSizeDisplay.innerHTML = String(event.detail.size);
      this.engravingSize.value = String(event.detail.size);
    }
    this.engravingDetailsContainer.classList.remove("hidden");
    this.engravingDetailsContainer.classList.add("flex");
    this.engravingReferenceInput.value = event.detail.reference;
  }
  handleReset() {
    this.resetEngravingInformationDisplay();
    this.resetEngravingSettings();
    GlobalEvents.emit("engraving:reset");
  }
  //reset engraving settings including modal
  resetEngravingSettings() {
    this.engravingButton.removeAttribute("data-engraving-added");
    this.setPreviewText("");
    this.resetFontFamily();
    this.setFontFamily(this.fontInputs[0].value);
    if (this.engravingObject.enable_font_size) {
      this.textInput.value = "";
      this.setFontSize(this.engravingObject.font_size_preset);
      this.setFontSizePreview("Medium");
    }
    this.setCurrentCanvas(void 0);
    this.engravingAddon.value = "";
    this.hideErrors();
    this.buildCanvas();
  }
  //reset displayed engraving information
  resetEngravingInformationDisplay() {
    this.engravingTextDisplay.innerHTML = "";
    this.engravingText.value = "";
    this.engravingFontDisplay.innerHTML = "";
    this.engravingFont.value = "";
    if (this.engravingObject.enable_font_size) {
      this.engravingSizeDisplay.innerHTML = "";
      this.engravingSize.value = "";
    }
    this.engravingDetailsContainer.classList.remove("flex");
    this.engravingDetailsContainer.classList.add("hidden");
  }
  showInfoModal() {
    return __async(this, null, function* () {
      if (this.isOpenEngravingInfo) {
        void this.closeInfo();
      } else {
        yield this.openInfo();
      }
    });
  }
  openInfo() {
    return __async(this, null, function* () {
      var _a;
      this.engravingInfo.open();
      this.isOpenEngravingInfo = true;
      (_a = this.engravingInfo.firstElementChild) == null ? void 0 : _a.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
    });
  }
  closeInfo() {
    return __async(this, null, function* () {
      this.engravingInfo.close();
      this.isOpenEngravingInfo = false;
    });
  }
  setCursorPosition() {
    this.cursorPosition = this.getInputSelection();
  }
  //get input selection
  getInputSelection() {
    const selectionStart = this.textInput.selectionStart;
    const selectionEnd = this.textInput.selectionEnd;
    if (selectionStart === selectionEnd) {
      return [selectionStart];
    } else {
      return [selectionStart, selectionEnd];
    }
  }
  //get dimensions of inputLine
  getLineDimensions(inputLine) {
    var _a, _b;
    if (/^\s*$/.test(inputLine)) {
      var lineSizeObject = (_a = this.canvasContext) == null ? void 0 : _a.measureText("o");
    } else {
      var lineSizeObject = (_b = this.canvasContext) == null ? void 0 : _b.measureText(inputLine);
    }
    var lineAscent = lineSizeObject.actualBoundingBoxAscent;
    var lineDescent = lineSizeObject.actualBoundingBoxDescent;
    var lineWidth = lineSizeObject.width;
    return { lineAscent, lineDescent, lineWidth };
  }
  waitForNextAnimationFrame() {
    return new Promise(requestAnimationFrame);
  }
  //calculates euclidean distance for circle bounding box
  calculateDistanceToCenter(x1, y1, x2, y2) {
    return Math.sqrt(__pow(x1 - x2, 2) + __pow(y1 - y2, 2));
  }
  //set starting values
  setBaseValues() {
    this.fontInputs[0].checked = true;
    this.canvasContext = this.canvas.getContext("2d");
    this.drawAreaFormat = this.engravingObject.input_form;
    this.fontFamily = this.fontInputs[0].value;
    this.fontSize = this.engravingObject.font_size_preset;
    this.fontSizePreset = this.engravingObject.font_size_preset;
    this.fontMin = this.engravingObject.font_size_minimum;
    this.fontMax = this.engravingObject.font_size_maximum;
    this.fontColor = this.engravingObject.font_color ? this.engravingObject.font_color : this.defaultEngraving.font_color;
  }
};
__decorateClass([
  query("[data-engraving-modal]")
], PbShopEngravingV2.prototype, "engravingModal", 2);
__decorateClass([
  query("[data-engraving-button]")
], PbShopEngravingV2.prototype, "engravingButton", 2);
__decorateClass([
  query("[data-engaving-details]")
], PbShopEngravingV2.prototype, "engravingDetailsContainer", 2);
__decorateClass([
  query("#engraving-reference")
], PbShopEngravingV2.prototype, "engravingReferenceInput", 2);
__decorateClass([
  query("#engraving-text-display")
], PbShopEngravingV2.prototype, "engravingTextDisplay", 2);
__decorateClass([
  query("#engraving-text")
], PbShopEngravingV2.prototype, "engravingText", 2);
__decorateClass([
  query("#engraving-font-display")
], PbShopEngravingV2.prototype, "engravingFontDisplay", 2);
__decorateClass([
  query("#engraving-font")
], PbShopEngravingV2.prototype, "engravingFont", 2);
__decorateClass([
  query("#engraving-size-display")
], PbShopEngravingV2.prototype, "engravingSizeDisplay", 2);
__decorateClass([
  query("#engraving-size")
], PbShopEngravingV2.prototype, "engravingSize", 2);
__decorateClass([
  query("#engravingImage")
], PbShopEngravingV2.prototype, "engravingImage", 2);
__decorateClass([
  query("[data-engraving-addon]")
], PbShopEngravingV2.prototype, "engravingAddon", 2);
__decorateClass([
  liquidValue("product.metafields.custom.engraving_v2_template.value.engraving_item.value.selected_or_first_available_variant.id")
], PbShopEngravingV2.prototype, "engravingAddonId", 2);
__decorateClass([
  liquidValue("metaobjects.engraving_v2.default.engraving_item.value.selected_or_first_available_variant.id")
], PbShopEngravingV2.prototype, "defaultAddonId", 2);
__decorateClass([
  liquidValue("product.metafields.custom.engraving_v2_template.value")
], PbShopEngravingV2.prototype, "engravingObject", 2);
__decorateClass([
  liquidValue("metaobjects.engraving_v2.default")
], PbShopEngravingV2.prototype, "defaultEngraving", 2);
__decorateClass([
  query("[data-engraving-canvas]")
], PbShopEngravingV2.prototype, "canvas", 2);
__decorateClass([
  query("[data-canvas-container]")
], PbShopEngravingV2.prototype, "canvasContainer", 2);
__decorateClass([
  queryAll("[data-setting-container]")
], PbShopEngravingV2.prototype, "settingContainers", 2);
__decorateClass([
  queryAll("[data-open-setting-container]")
], PbShopEngravingV2.prototype, "settingContainerButtons", 2);
__decorateClass([
  queryAll("[data-accordion]")
], PbShopEngravingV2.prototype, "accordions", 2);
__decorateClass([
  queryAll("[data-chevron]")
], PbShopEngravingV2.prototype, "chevrons", 2);
__decorateClass([
  query("[data-text-input]")
], PbShopEngravingV2.prototype, "textInput", 2);
__decorateClass([
  queryAll("[data-font-input]")
], PbShopEngravingV2.prototype, "fontInputs", 2);
__decorateClass([
  query("[data-font-size-input]")
], PbShopEngravingV2.prototype, "fontSizeInput", 2);
__decorateClass([
  queryAll("[data-font-size-button]")
], PbShopEngravingV2.prototype, "fontSizeButtons", 2);
__decorateClass([
  query("[engraving-error-container]")
], PbShopEngravingV2.prototype, "errorContainer", 2);
__decorateClass([
  query("[name=submitEngraving]")
], PbShopEngravingV2.prototype, "submitButton", 2);
__decorateClass([
  query("[data-engraving-info]")
], PbShopEngravingV2.prototype, "engravingInfo", 2);
__decorateClass([
  onClick("[data-engraving-button]")
], PbShopEngravingV2.prototype, "openModal", 1);
__decorateClass([
  onClick("[close-btn]")
], PbShopEngravingV2.prototype, "closeModal", 1);
__decorateClass([
  onClick("[data-open-setting-container]")
], PbShopEngravingV2.prototype, "handleClick", 1);
__decorateClass([
  onClick("[data-open-button]")
], PbShopEngravingV2.prototype, "handleOpenButtonClick", 1);
__decorateClass([
  on("change", "[data-text-input]"),
  on("input", "[data-text-input]")
], PbShopEngravingV2.prototype, "handleTextInput", 1);
__decorateClass([
  onClick("[data-symbol]")
], PbShopEngravingV2.prototype, "identifySymbol", 1);
__decorateClass([
  onClick("[data-font]")
], PbShopEngravingV2.prototype, "updateFontFamily", 1);
__decorateClass([
  onClick("[data-font-size-small]")
], PbShopEngravingV2.prototype, "setSmallFontSize", 1);
__decorateClass([
  onClick("[data-font-size-medium]")
], PbShopEngravingV2.prototype, "setMediumFontSize", 1);
__decorateClass([
  onClick("[data-font-size-large]")
], PbShopEngravingV2.prototype, "setLargeFontSize", 1);
__decorateClass([
  onClick("[data-submit-engraving]")
], PbShopEngravingV2.prototype, "saveEngraving", 1);
__decorateClass([
  globalOn("engraving:set")
], PbShopEngravingV2.prototype, "setEngraving", 1);
__decorateClass([
  onClick("[data-reset-engraving]"),
  globalOn("product:variantChanged"),
  globalOn("product:formSubmitted")
], PbShopEngravingV2.prototype, "handleReset", 1);
__decorateClass([
  onClick("[data-info-open]")
], PbShopEngravingV2.prototype, "showInfoModal", 1);
__decorateClass([
  on("focus", "[data-text-input]"),
  on("click", "[data-text-input]"),
  on("keyup", "[data-text-input]")
], PbShopEngravingV2.prototype, "setCursorPosition", 1);
PbShopEngravingV2 = __decorateClass([
  defineElement("pb-shop-engraving-v2")
], PbShopEngravingV2);
export {
  PbShopEngravingV2
};
